import React from 'react'

export default function pricing2() {
  return (
    <div>pricing2</div>
  )
}
